import axios from 'axios';
import useSWR from 'swr';

interface MKLPYieldData {
  apr: number;
}

export const useMklpApr = () => {
  const { data, isValidating } = useSWR<number>(
    ['MklpApr'],
    async () => {
      const response = await axios.get<MKLPYieldData>(
        'https://aptos-app-git-feat-mklp-apr-port-fi.vercel.app/api/mklp-apr',
      );
      return Number(response.data.apr) || 0;
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      errorRetryCount: 0,
    },
  );

  return {
    mklpApr: data,
    isMklpAprLoading: isValidating,
  };
};
